module.exports = __webpack_public_path__ + "static/media/print-logo-2.db01d49b.png";